<template>
  <a :href="backLink" :title="label" v-if="withLabel">
    <div class="page-nav__icon page-nav__icon--arrow-left"></div> {{ label }}
  </a>
  <a :href="backLink" :title="label" v-else>
    <div class="page-nav__icon page-nav__icon--grid"></div>
  </a>
</template>
<script>
	export default {
		props: {
			label: {
				type: String,
			},
			url: {
				type: String,
			},
			withLabel: {
				type: [String, Boolean],
				default: false,
			}
		},
		computed: {
			backLink() {
				if (this.url) {
			    return this.url;
				} else {
					if (document.referrer && document.referrer.indexOf(window.App.getUrl('base')) !== -1) {
						return document.referrer;
					} else {
						return window.App.getUrl('base');
					}
				}
			}
		},
	}
</script>



// WEBPACK FOOTER //
// public/themes/frontend/imbotex/assets/js/theme-components/BackLink.vue